'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border: solid 1px #E4E4E4;\n  border-radius: 5px;\n  margin: 0 10px 10px 0;\n  overflow: hidden;\n  width: 100%;\n'], ['\n  background-color: #fff;\n  border: solid 1px #E4E4E4;\n  border-radius: 5px;\n  margin: 0 10px 10px 0;\n  overflow: hidden;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border-bottom: 1px solid rgb(234, 234, 234);\n  display: flex;\n  flex-wrap: wrap;\n  text-transform: uppercase;\n  padding: 5px 10px;\n'], ['\n  border-bottom: 1px solid rgb(234, 234, 234);\n  display: flex;\n  flex-wrap: wrap;\n  text-transform: uppercase;\n  padding: 5px 10px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  height: calc(100% - 35px); /* -title height */\n  overflow-x: scroll;\n'], ['\n  height: calc(100% - 35px); /* -title height */\n  overflow-x: scroll;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  align-items: center;\n  border-bottom: 1px solid rgb(250, 250, 250);\n  display: flex;\n  padding: 5px 10px;\n'], ['\n  align-items: center;\n  border-bottom: 1px solid rgb(250, 250, 250);\n  display: flex;\n  padding: 5px 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactInspector = require('react-inspector');

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);

var Title = _styledComponents2.default.div(_templateObject2);

var LogsContainer = _styledComponents2.default.pre(_templateObject3);

var Log = _styledComponents2.default.div(_templateObject4);

var ActionLogger = function ActionLogger(_ref) {
  var devNovelInstance = _ref.devNovelInstance;
  return _react2.default.createElement(
    Container,
    null,
    _react2.default.createElement(
      Title,
      null,
      'Action logger'
    ),
    _react2.default.createElement(
      LogsContainer,
      null,
      devNovelInstance.actionLogs.peek().reverse().map(function (_ref2, idx) {
        var name = _ref2.name,
            data = _ref2.data;
        return _react2.default.createElement(
          Log,
          { key: idx },
          _react2.default.createElement(_reactInspector.Inspector, { name: name, data: (0, _mobx.toJS)(data) })
        );
      })
    )
  );
};

exports.default = (0, _mobxReact.observer)(ActionLogger);


//////////////////
// WEBPACK FOOTER
// ./node_modules/dev-novel/dist/ui/action-logger.js
// module id = 456
// module chunks = 0